import types from './actionTypes';

const initialState = {
  loading: false,
  surveyForms: [],
  error: '',
};

const surveyFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_SURVEY_FORM_STATE:
      return initialState;
    case types.CREATE_SURVEY_FORM.REQUEST:
    case types.UPDATE_SURVEY_FORM.REQUEST:
    case types.SYNC_SURVEY_FORMS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_SURVEY_FORM.SUCCESS:
    case types.UPDATE_SURVEY_FORM.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_SURVEY_FORMS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        surveyForms: [...action.surveyForms],
      };
    case types.CREATE_SURVEY_FORM.FAILURE:
    case types.UPDATE_SURVEY_FORM.FAILURE:
    case types.SYNC_SURVEY_FORMS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default surveyFormReducer;
